import { Card, Grid, IconButton, Tooltip } from '@mui/material';
import { useState } from 'react';
import AutocompleteField from '../../formFields/autocompleteField';
import DatePickerField from '../../formFields/datePickerField';
import { useSelector } from 'react-redux';
import CheckboxField from '../../formFields/checkBoxField';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
export const SeguridadSocial = (props: any) => {
  // REDUX
  const { sgsst_list_select }: any = useSelector((state: any) => state.sgsst);
  const { arl_list_select }: any = useSelector((state: any) => state.arl);

  // const [value, setValue] = useState<Dayjs | null | undefined | any | string>(dayjs('2022-04-07'));
  const [value, setValue] = useState<Date | null>(new Date());
  const [cleared, setCleared] = useState<boolean>(false);

  const {
    formField: { sgsst, arl, constitution_date, ley_1429_2010, ley_590_2000, ley_1607_2012 },
  } = props;

  const tdocument = [
    { label: 'Cedula', id: 'hjgjgjhgh' },
    { label: 'Tarjeta de identidad', id: 'sdfdf' },
  ];

  return (
    <div>
      <Grid container spacing={2}>
        <Grid size={{ xs: 4 }}>
          <AutocompleteField options={sgsst_list_select} name={sgsst.name} label={sgsst.label} />
        </Grid>
        <Grid size={{ xs: 4 }}>
          <AutocompleteField options={arl_list_select} name={arl.name} label={arl.label} />
        </Grid>
        <Grid size={{ xs: 4 }}>
          <DatePickerField label={constitution_date.label} name={constitution_date.name} />
        </Grid>
      </Grid>
      <Grid container spacing={2} style={{ marginTop: 15 }}>
        <Grid size={{ xs: 4 }}>
          <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
            <CheckboxField name={ley_1429_2010.name} label={ley_1429_2010.label} />
            <Tooltip title="La presente ley tiene por objeto la formalización y la generación de empleo, con el fin de generar incentivos a la formalización en las etapas iniciales de la creación de empresas; de tal manera que aumenten los beneficios y disminuyan los costos de formalizarse.">
              <IconButton>
                <HelpOutlineOutlinedIcon color="primary" />
              </IconButton>
            </Tooltip>
          </div>
        </Grid>
        <Grid size={{ xs: 4 }}>
          <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
            <CheckboxField name={ley_590_2000.name} label={ley_590_2000.label} />
            <Tooltip title="Promover el desarrollo integral de las micro, pequeñas y medianas empresas en consideración a sus aptitudes para la generación de empleo, el desarrollo regional, la integración entre sectores económicos, el aprovechamiento productivo de pequeños capitales y teniendo en cuenta la capacidad empresarial de los colombianos.">
              <IconButton>
                <HelpOutlineOutlinedIcon color="primary" />
              </IconButton>
            </Tooltip>
          </div>
        </Grid>
        <Grid size={{ xs: 4 }}>
          <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
            <CheckboxField name={ley_1607_2012.name} label={ley_1607_2012.label} />
            <Tooltip title="Declaración Voluntaria del Impuesto sobre la Renta. El impuesto sobre la renta y complementarios, a cargo de los contribuyentes no obligados a declarar, es el que resulte de sumar las retenciones en la fuente por todo concepto que deban aplicarse a los pagos o abonos en cuenta, según el caso, realizados al contribuyente durante el respectivo año o período gravable.">
              <IconButton>
                <HelpOutlineOutlinedIcon color="primary" />
              </IconButton>
            </Tooltip>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};
